export const IMAGE_HOST = "https://cdn.bvote.vn";

export const MAX_PRICE = 50000000;

export const COMBO_LIST = [
  {
    id: "1",
    name: "combo1",
    price: 2000,
    point: 1,
  },
  {
    id: "2",
    name: "combo2",
    price: 20000,
    point: 10,
  },
  {
    id: "3",
    name: "combo3",
    price: 50000,
    point: 25,
  },
  {
    id: "4",
    name: "combo4",
    price: 100000,
    point: 50,
  },
];

export const TABLE_MAP = {
  1: "Album của năm",
  2: "Chương trình của năm",
  3: "Chuỗi chương trình của năm",
  4: "Nhà sản xuất của năm",
  5: "Nhạc sĩ của năm",
  6: "Bài hát của năm",
  7: "Music video của năm",
  8: "Nghệ sĩ mới của năm",
  9: "Nữ ca sĩ của năm",
  10: "Nam ca sĩ của năm",
  // 11: "Chiến tích thể thao của năm",
  12: "Gương mặt thể thao của năm",
  13: "Gương mặt trẻ thể thao của năm",
};

const tableArr = Object.entries(TABLE_MAP).map((m) => ({
  label: m[1],
  id: m[0],
  img: `/images/table/bang-${m[0]}.png`,
}));

export const musics = tableArr.slice(0, 10);
export const sports = tableArr.slice(10);

// export const COMBO_LIST = [
//   {
//     id: "1",
//     combo: "50 điểm",
//     priceDisplay: "20.000 đ",
//     price: 20000,
//     point: 50,
//   },
//   {
//     id: "2",
//     combo: "150 điểm",
//     priceDisplay: "50.000 đ",
//     price: 50000,
//     point: 150,
//   },
//   {
//     id: "3",
//     combo: "450 điểm",
//     priceDisplay: "100.000 đ",
//     price: 100000,
//     point: 450,
//   },
//   {
//     id: "4",
//     combo: "2500 điểm",
//     priceDisplay: "200.000 đ",
//     price: 200000,
//     point: 2500,
//   },
//   {
//     id: "5",
//     combo: "5000 điểm",
//     priceDisplay: "300.000 đ",
//     price: 300000,
//     point: 5000,
//   },
// ];
